import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./sdAppModule";

declare var HybridBootstrap: any;

// This is the starting point for the application bootstrap.
HybridBootstrap = function (): void {
  platformBrowserDynamic().bootstrapModule(AppModule);
};
